var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form",
                { on: { submit: _vm.onSubmit } },
                [
                  _c(
                    "b-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("label", { attrs: { for: "selecUserBI" } }, [
                              _vm._v("User PBI"),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-form-select", {
                                attrs: {
                                  id: "selecUserBI",
                                  options: _vm.userBIOptions,
                                  required: "",
                                },
                                model: {
                                  value: _vm.userBI,
                                  callback: function ($$v) {
                                    _vm.userBI = $$v
                                  },
                                  expression: "userBI",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "12", lg: "12" } },
                            [
                              _c(
                                "b-alert",
                                {
                                  attrs: {
                                    show: _vm.dismissCountDown,
                                    dismissible: "",
                                    variant: "danger",
                                  },
                                  on: {
                                    dismissed: function ($event) {
                                      _vm.dismissCountDown = 0
                                    },
                                    "dismiss-count-down": _vm.countDownChanged,
                                  },
                                },
                                [
                                  _c("p", [_vm._v(_vm._s(_vm.dangerMessage))]),
                                  _c("b-progress", {
                                    attrs: {
                                      variant: "danger",
                                      max: _vm.dismissSecs,
                                      value: _vm.dismissCountDown,
                                      height: "4px",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }